import React, { useState, useEffect } from 'react';
import { createModel } from 'hox';
import useGlobalModel from '@/model/globalModel';
import { ISCMPRoGoodsDetail, ISCMPurchaseRoFormFields } from './scmPurchaseRoType';
import { purchaseRoService } from './scmPurchaseRoService';
import moment from 'moment';
import { useScmSaleRoDetailModel } from '../scmSaleRo/scmSaleRoModel';

export type ISCMPRoDescType = {
	numAll: number;
	kindAll: number;
	stockInAll: number;
	rejectAll: number;
	amountAll: number;
	actualAmount: number;
	settleAmountAll: number;
	giftsAmount: number;
	[key: string]: any;
};
const initDesc = {
	actualAmount: 0, //实际总价合计 （数量*单价）
	//对应展示字段
	numAll: 0, //开单
	kindAll: 0, //种类
	stockInAll: 0, //已入库
	rejectAll: 0, //驳回
	amountAll: 0, //总计   （去除下浮，赠品的金额）
	stockAmountAll: 0, //出库总计   （去除下浮）
	settleAmountAll: 0, //入库总计
	giftsAmount: 0,
};
export const usePurchaseRoDetailsModel = createModel(function () {
	const {
		user: { shopId, shopName, userName },
	} = useGlobalModel();
	const { getTreeNodeName } = useScmSaleRoDetailModel();

	const initFormVal = {
		shopName,
		createUser: userName,
		operator: userName,
		returnCode: '',
		status: '',
		discountTotalAmount: '0.00', //优惠总额
		receivedAmount: '0.00', //已收金额
		favorableAmount: '0', //整单优惠
		totalAmount: '0.00', //应付金额
		discountRate: '0', //整单下浮
		stockIoTotalAmount: '0.00', //入库金额
	} as ISCMPurchaseRoFormFields;

	//新增缓存
	const [lookFormVal, setLookFormVal] = useState<ISCMPurchaseRoFormFields>(initFormVal);
	const [lookGoodsList, setLookGoodsList] = useState<ISCMPRoGoodsDetail[]>([]);
	const [lookDesc, setLookDesc] = useState<ISCMPRoDescType>(initDesc);

	useEffect(() => {
		let newDesc: ISCMPRoDescType = { ...initDesc };
		lookGoodsList.forEach((item) => {
			newDesc.numAll += Number(item.num);
			newDesc.stockInAll += Number(item.confirmNum);
			newDesc.rejectAll += Number(item.rejectNum);
			newDesc.amountAll += Number(item.amount);
			newDesc.actualAmount += Number(item.num) * Number(item.price);
			newDesc.stockAmountAll += Number(item?.stockIoAmount ?? 0);
			newDesc.settleAmountAll += Number(item.settleIoAmount ?? 0);
			newDesc.giftsAmount += +Number(item.giftsNum) * +(item.price ?? 0);
		});
		newDesc.kindAll = new Set(lookGoodsList.map((item) => item.materialCode)).size ?? 0;
		setLookDesc(newDesc);
	}, [lookGoodsList]);

	useEffect(() => {
		resetLookCatch();
		setLookFormVal({ ...initFormVal, shopId, shopName, createUser: userName });
	}, [shopId]);

	const resetLookCatch = () => {
		setLookFormVal(initFormVal);
		setLookGoodsList([]);
	};

	//获取一条数据
	const getPRoDetailOne = async (id: string) => {
		let { retData } = await purchaseRoService.one(id);
		if (retData) {
			let { details, ...formVal } = retData;
			setLookGoodsList(() => details.map((item) => ({ ...item, key: item.id })));
			setLookFormVal({
				...formVal,
				returnTime: formVal.returnTime ? moment(formVal.returnTime) : null,
				invoiceTypeName: getTreeNodeName(formVal.invoiceTypeCode),
			});
		}
	};

	return {
		lookFormVal,
		resetLookCatch,
		getPRoDetailOne,
		setLookFormVal,
		lookGoodsList,
		setLookGoodsList,
		lookDesc,
		setLookDesc,
	};
});
